import { customHeaders, requestApi } from 'api/api'
import { v4 as uuidv4 } from 'uuid'
import {
  PayoutRequest,
  PayoutResponse,
  TransferRequest,
  TransferResponse,
  TransferWalletsReponse,
  TransferWalletsRequest,
} from 'types/unifiedPayouts/unifiedPayouts'
import {
  PayUnifiedPayoutsV2Payload,
  UnifiedPayoutsV2AuthRequest,
  UnifiedPayoutsV2AuthResponse,
  UnifiedPayoutsV2Response,
} from 'types/unifiedPayouts/unifiedPayoutsV2'

export const postPayoutsTransfer = (data: TransferRequest): Promise<TransferResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v2/transfers',
    method: 'POST',
    data,
    headers: {
      ...customHeaders,
      'idempotency-key': uuidv4(),
    } as any,
  })
}

export const getPayoutsTransferWallets = ({
  walletId,
  currencyCode,
  walletType,
  customerReference,
}: TransferWalletsRequest): Promise<TransferWalletsReponse[]> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: `/payment/v1/transfers/${walletId}/beneficiaries`,
    method: 'GET',
    params: {
      ...(currencyCode && { currencyCode }),
      ...(customerReference && { customerReference }),
      ...(walletType && { walletType }),
    },
  })
}

export const postPayout = (data: PayoutRequest): Promise<PayoutResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v1/payouts',
    method: 'POST',
    data,
    headers: {
      ...customHeaders,
      'x-idempotency-key': uuidv4(),
    } as any,
  })
}

export const postUnifiedPayoutsV2PreAuth = (
  payload: PayUnifiedPayoutsV2Payload
): Promise<UnifiedPayoutsV2Response> => {
  const { verificationId, request } = payload

  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/payment/v2/payouts',
    method: 'POST',
    data: request,
    headers: {
      ...customHeaders,
      'x-idempotency-key': uuidv4(),
      ...(verificationId && { 'x-verification-id': verificationId }),
    } as any,
  })
}

export const postUnifiedPayoutsV2PostAuth = (
  data: UnifiedPayoutsV2AuthRequest
): Promise<UnifiedPayoutsV2AuthResponse> => {
  return requestApi({
    url: '',
    baseUrl: data?.mfaCallbackUrl,
    method: 'POST',
    data: {
      challenge: data?.challenge,
      tokenResponse: data?.tokenResponse,
    },
    headers: {
      'x-idempotency-key': uuidv4(),
    } as any,
  })
}
